import { ITranslationsData } from "hooks/translations.interfaces";
import {
  IFilters,
  initialDepartureTimeRangeObj,
  initialFiltersState,
} from "redux/filters";
import { ISearchForm } from "redux/searchForm";

export const resetFilters = (
  searchForm: ISearchForm,
  filters: IFilters,
  translations: ITranslationsData,
) => {
  const translationsFilters = translations.filters;
  const lenght = searchForm.flights.length;

  const departureTimeRanges = new Array(lenght).fill(
    initialDepartureTimeRangeObj,
  );

  const maxDurations = new Array(lenght).fill(
    translationsFilters.filterValues.maxDuration,
  );

  let initialFilters: IFilters = {
    ...initialFiltersState,
    departureTime: {
      touched: false,
      departureTimeRanges: departureTimeRanges,
    },
    maxDurations: {
      touched: false,
      maxDurations: maxDurations,
    },
    allAirlines: filters.allAirlines,
  };

  return { initialFilters, filters };
};
